import React, { useCallback, useMemo, useReducer } from 'react';
import DV                                          from 'ts-data-validator';

import promotionsConstants    from './promotions.constants';
import PromotionsContext      from './promotions.context';
import promotionsReducer      from './promotions.reducer';
import promotionsInitialState from './promotions.state';

import useRequest from '../../common/services/request';

/**
 * @type {React.FC}
 */
function PromotionsProvider({
  children,
  value,
}) {
  const [state, dispatch] = useReducer(promotionsReducer, {
    ...promotionsInitialState,
    items:              value.items || promotionsInitialState.items,
    headItems:          value.headItems || promotionsInitialState.headItems,
    count:              value.count || promotionsInitialState.count,
    article:            !DV.isUndefined(value.article)
                          ? {
        buttonLink:        value.article.buttonLink || promotionsInitialState.article.buttonLink,
        buttonName:        value.article.buttonName || promotionsInitialState.article.buttonName,
        contactButtonName: value.article.contactButtonName || promotionsInitialState.article.contactButtonName,
        newsId:
                           +value.article.newsId || promotionsInitialState.article.newsId,
        label:             value.article.label || promotionsInitialState.article.label,
        headImage:
                           value.article.headImage || promotionsInitialState.article.headImage,
        content:
                           value.article.content || promotionsInitialState.article.content,
        createdAt:
                           value.article.createdAt || promotionsInitialState.article.createdAt,
        createdAtIso:
                           value.article.createdAtIso || promotionsInitialState.article.createdAtIso,
        updatedAtIso:
                           value.article.updatedAtIso || promotionsInitialState.article.updatedAtIso,
        readingTime:
                           value.article.readingTime ||
                             promotionsInitialState.article.readingTime,
        relatedNews:
                           value.article.relatedNews ||
                             promotionsInitialState.article.relatedNews,
        meta:              {
          title:
            value.article.metaTitle ||
            promotionsInitialState.article.meta.title,
          meta: {
            keywords:
              value.article.metaKeywords ||
              promotionsInitialState.article.meta.meta.keywords,
            description:
              value.article.metaDescription ||
                promotionsInitialState.article.meta.meta.description,
            canonical:
              value.article.metaCanonical ||
                promotionsInitialState.article.meta.meta.canonical,
          },
        },
      }
                          : { ...promotionsInitialState.article },
    detailLoaded:       !DV.isUndefined(value.article),
    initialStateLoaded: DV.isNotEmptyArray(value.items),
  });
  const { get }           = useRequest();

  const getPromotionsDetail = useCallback(
    (urlKey) => {
      dispatch({ type: promotionsConstants.GET_PROMOTIONS_DETAIL_REQUEST });

      return get(`/api/akcii/${urlKey}`)
        .then((response) =>
          dispatch({
            type: promotionsConstants.GET_PROMOTIONS_DETAIL_SUCCESS,
            ...response,
          }),
        )
        .catch((error) =>
          dispatch({
            type: promotionsConstants.GET_PROMOTIONS_DETAIL_FAILURE,
            ...error,
          }),
        );
    },
    [dispatch],
  );

  const getPromotionsList = useCallback(() => {
    dispatch({ type: promotionsConstants.GET_PROMOTIONS_LIST_REQUEST });
    return get('/api/akcii')
      .then((response) =>
        dispatch({
          type: promotionsConstants.GET_PROMOTIONS_LIST_SUCCESS,
          ...response,
        }),
      )
      .catch((error) =>
        dispatch({
          type: promotionsConstants.GET_PROMOTIONS_LIST_FAILURE,
          ...error,
        }),
      );
  }, [dispatch]);

  const resetPromotionsDetail = useCallback(() => {
    dispatch({
      type: promotionsConstants.PROMOTIONS_DETAIL_RESET_INITIAL_STATE,
    });
  }, [dispatch]);

  const showMore = useCallback(
    (page, limit) => {
      dispatch({ type: promotionsConstants.PROMOTIONS_SHOW_MORE_REQUEST });

      const url = `/api/akcii?page=${page + 1}&limit=${limit}`;

      return get(url)
        .then((response) =>
          dispatch({
            type: promotionsConstants.PROMOTIONS_SHOW_MORE_SUCCESS,
            ...response,
            page: page + 1,
          }),
        )
        .catch((error) =>
          dispatch({
            type: promotionsConstants.PROMOTIONS_SHOW_MORE_FAILURE,
            ...error,
          }),
        );
    },
    [dispatch],
  );

  const context = useMemo(
    () => (
      {
        ...state,
        getPromotionsDetail,
        getPromotionsList,
        resetPromotionsDetail,
        showMore,
      }),
    [
      getPromotionsDetail,
      getPromotionsList,
      resetPromotionsDetail,
      showMore,
      state,
    ],
  );

  return (
    <PromotionsContext.Provider value={context}>
      {children}
    </PromotionsContext.Provider>
  );
}

export default PromotionsProvider;
